module.exports = __webpack_public_path__ + "img/协同智能化icon.4b6dbb02.png";